import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-skills-certificate-types',
  templateUrl: './skills-certificate-types.component.html',
  styleUrls: ['./skills-certificate-types.component.css']
})
export class SkillsCertificateTypesComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_skillscertificatetypes_grid')
                .setLoadDataFunction({
                    method: 2498,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'skillscertificatetypes_new',
                    text: 'skillscertificatetypes_new',
                    func: () => this.stateService?.go('skillscertificatetype', { skillscertificatetype_keyno: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('skillsCertificateTypes', {
//        templateUrl: 'views/components/views/skillsCertificateTypes/skillsCertificateTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_skillscertificatetypes_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'skillscertificatetypes_new',
//                    text: 'skillscertificatetypes_new',
//                    func: () => stateService.go('skillscertificatetype', { skillscertificatetype_keyno: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }])
//                .setLoadDataFunction({
//                    method: 2498,
//                    parameters: {}
//                });

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
